<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-file-plus"
        class="mx-2"
        @click="addItem"
        >{{ $t('new') | capitalize }}
      </vs-button>

      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
      <!--
          <vs-button
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-filter"
          class="mx-2"
          radius
          @click="openFilter"
        ></vs-button>
        -->
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('name') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('frequency') | capitalize }}
      </vs-th>
      <th class="qb-sticky">
        {{ $t('actions') }}
      </th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].name | capitalize }}
        </vs-td>
        <vs-td>
          {{ data[i].frequency_name | capitalize }}
        </vs-td>
        <vs-td>
          <div>
            <action-icon
              icon="EditIcon"
              :tooltip="$t('edit')"
              @click="editItem(data[i])"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
  
  <script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'

export default {
  components: {
    ActionIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    addItem() {
      this.$emit('add')
    },
    editItem(item) {
      this.$emit('edit',item)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
  
  <style>
</style>
  